import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Inventory } from '../../inventory';
import { KitComponent } from '../../_models/kitComponent';
import { ProductAttribute } from '../../_models/productAttribute';
import { Subject } from 'rxjs';
import { Product } from '../../_models/product';
import { Caller } from '../../_models/caller';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.css']
})
export class EditRoleComponent implements OnInit {
  editRole: any = {
    roleName: ""
  };
  groupList: any = [
    length
  ];

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User) {
    this.getAllActiveSecurityType();
    this.api.getOrgRolesById(this.route.snapshot.params['id']).subscribe((data: any) => {
      this.editRole = data;
      this.checkSecurity();
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  checkSecurity() {
    for (let i = 0; i < this.groupList.length; i++) {
      this.groupList[i].enableAll = false;
      let length = 0;
      for (let j = 0; j < this.groupList[i].securityTypes.length; j++) {
        let index = _.findIndex(this.editRole.settings, { 'applicationSecurityTypeId': this.groupList[i].securityTypes[j].securityTypeId });
        if (index > -1) {
          this.groupList[i].securityTypes[j].status = 'ACTIVE';
          this.groupList[i].securityTypes[j].enabled = true;
          length = length + 1;
        } else {
          this.groupList[i].securityTypes[j].status = 'IN_ACTIVE';
          this.groupList[i].securityTypes[j].enabled = false;
        }
      }
      if (length === (this.groupList[i] || {}).securityTypes.length) {
        this.groupList[i].enableAll = true;
      }
    }
  }

  getAllActiveSecurityType() {
    this.g.loaderDisplay = "display";
    this.api.getAllActiveSecurityType("1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.groupList = data;
      for (let i = 0; i < this.groupList.length; i++) {
        for (let j = 0; j < this.groupList[i].securityTypes.length; j++) {
          if (this.groupList[i].securityTypes[j].status === 'ACTIVE') {
            this.groupList[i].securityTypes[j].status = 'IN_ACTIVE'
          }
          this.groupList[i].securityTypes[j].enabled = false;
          if (this.groupList[i].securityTypes[j].securityCode === 'view-products' || this.groupList[i].securityTypes[j].securityCode === 'view-customers') {
            this.groupList[i].securityTypes[j].enabled = true;
            this.groupList[i].securityTypes[j].status = 'ACTIVE';
          }
        }

      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  ngOnInit(): void {
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

  statusChange(action, role: any = {}, i = '') {
    if (action.enabled) {
      action.status = 'ACTIVE';
      if (i !== '') {
        if (!this.groupList[i]['enableAll']) {
          let x = 0;
          role.securityTypes.forEach((s) => {
            if (s.enabled) {
              x = x + 1;
            }
          });
          if (x === role.securityTypes.length) {
            this.groupList[i].enableAll = true;
          }
        }
      }
    } else {
      if (i !== '') {
        if (this.groupList[i]['enableAll']) {
          this.groupList[i].enableAll = false;
        }
      }
      action.status = 'IN_ACTIVE';
    }

    this.changeStatus(action)
  }
  changeStatus(action) {
    this.g.loaderDisplay = "display";
    let request = [{
      "id": action.securityTypeId,
      "status": action.status
    }];
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + (action.enabled ? ('api/activateRole') : ('api/deActivateRole')), request,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('User', 'Status Changed Successfully');
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
  /*
   changeStatus(c,id) {

    let api = "";
    this.g.loaderDisplay = "display";
      if (c.enabled) {
      api = 'api/deActivateRole';
        c.status = "IN_ACTIVE";
      }
      else{
      api = 'api/activateRole';
        c.status ="ACTIVE";
      }
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
      this.http.post(environment.apiUrl + api,{
          "id" : c.applicationSecurityTypeId,
          "organizationId": 1,
          "status": c.status
        },
        {headers: header1}).subscribe(data => {
         if(data['code'] == "200"){
                    this.alertService.success('Settings','Status Updated Successfully');
                  }else{
                      this.alertService.error(data['message']);
                  }
  this.g.loaderDisplay = "";
        },
        (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        });
  }
  */

  allStatusChange(role) {
    if (role.enableAll && role.securityTypes.length) {
      for (let i = 0; i < role.securityTypes.length; i++) {
        role.securityTypes[i].enabled = true;
        role.securityTypes[i].status = 'ACTIVE';
      }
    } else {
      for (let j = 0; j < role.securityTypes.length; j++) {
        role.securityTypes[j].enabled = false;
        role.securityTypes[j].status = 'IN_ACTIVE';
      }
    }
  }
  submitRole() { }
}
